import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import FullScreenSpinner from "src/components/Spinner/FullScreenSpinner";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { IFairApplication } from "src/Types/module/fair/fairSingleMemberApplication";
import type { ISingleFair } from "src/Types/module/fair/singlefair";
import SingleFairInfo from "./SingleFairInformation";

const SingleFairApplicationPage = () => {
	const [status, setStatus] = useState<string>("");
	const { singleFairId } = useParams();

	const { data: singleFair, isLoading: isSingleFairLoading } =
		useApiQuery<ISingleFair>({
			endPoint: `/api/fair/get/single-fair/${singleFairId}`,
			queryKeys: ["Invoice", singleFairId],
		});

	const { data: fairs, isLoading: isFairLoading } = useApiQuery<
		IFairApplication[]
	>({
		endPoint: `/api/fair/applications`,
		queryKeys: ["FairApplication", status],
		params: { status },
	});

	if (isFairLoading || isSingleFairLoading) {
		return <FullScreenSpinner />;
	}

	return (
		<div>
			<Helmet>
				<title>BTTF - Single fair member information</title>
			</Helmet>
			<Container sx={{ mt: 4 }} maxWidth="xl">
				<Grid
					container
					direction="row"
					justifyContent="center"
					alignItems="stretch"
					spacing={3}
				>
					<Grid item xs={12}>
						{singleFair && <SingleFairInfo fairInfo={singleFair} />}
						{/* ! Don't remove this, might needed later! */}
						{/* <Card>
							<SingleFairApplicationTable
								isLoading={isFairLoading || isSingleFairLoading}
								fairs={fairs}
								setStatus={setStatus}
								status={status}
							/>
						</Card> */}
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default SingleFairApplicationPage;
